import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/whatsapp-templates/searchbar";
import TemplatesTable from "../../../containers/admin/whatsapp-templates/table";
import { getWhatsappTemplatesRequest } from "../../../modules/admin-modules/whatsapp-templates/Actions";

const WhatsappTemplates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role.some((role) => role?.name === "Super Admin");

  useEffect(() => {
    if (isLoading) return;

    if (user?.role && Array.isArray(user.role)) {
      if (!isSuperAdmin) {
        navigate("/dashboard/students");
        return;
      }
      dispatch(getWhatsappTemplatesRequest());
    }
  }, [user, isLoading, isSuperAdmin, navigate, dispatch]);

  if (isLoading || !user?.role || !isSuperAdmin) {
    return null;
  }

  return (
    <Layout>
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filterType={filterType}
        setFilterType={setFilterType}
      />
      <TemplatesTable searchTerm={searchTerm} filterType={filterType} />
    </Layout>
  );
};

export default WhatsappTemplates;
